import { Helmet } from "react-helmet-async";
import { COMPANY } from "../../lib/api";

export function Seo({ title, description, path = "" }) {
  const fullTitle = title
    ? `${title} | ${COMPANY.name}`
    : `${COMPANY.name} — ${COMPANY.tagline} | Perth WA`;
  const desc =
    description ||
    "West Face Roofing — The Roofing Specialists. Roof repairs, re-roofing, commercial roofing, gutters, skylights & leak detection across Perth, WA. Building roofs since 2010.";
  const url = `https://westfaceroofing.com.au${path}`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    name: COMPANY.name,
    image: "https://westfaceroofing.com.au/og.jpg",
    "@id": "https://westfaceroofing.com.au",
    url: "https://westfaceroofing.com.au",
    telephone: "+61892472962",
    email: COMPANY.email,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Coode Street",
      addressLocality: "South Perth",
      addressRegion: "WA",
      postalCode: "6151",
      addressCountry: "AU",
    },
    areaServed: {
      "@type": "GeoCircle",
      geoMidpoint: { "@type": "GeoCoordinates", latitude: -31.986, longitude: 115.864 },
      geoRadius: 20000,
    },
    openingHours: "Mo-Fr 07:00-17:00, Sa 08:00-13:00",
    foundingDate: "2010",
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
